import organizationLabels from "@/organization/constants/org-labels"

export function getOrgCustomLabel(orgId: string, defaultValue: string): string {
  const customValue = organizationLabels?.[orgId]?.[defaultValue]

  return customValue ?? defaultValue
}
